import { createSlice } from '@reduxjs/toolkit';

import { Filter } from '~/evifields/src/types/Filter';
import {
  ClauseSuggestions,
  PilotField,
  PilotFieldSection,
} from '~/redux/api/methods/alert';
import { DepartmentTree } from '~/types/Department';
import { FolderTree } from '~/types/FolderTree';

type OptionType = { label: string; value: string } | null;

type State = {
  config: {
    name: string;
    message: string;
    occurrenceInterval: number | null;
    occurrencePeriod: OptionType;
    startDate: Date;
    occurrenceEndDate: Date | null;
    occurrenceEndTimespan: OptionType;
    occurrenceEndLimit: number | null;
    filters: Filter[];
    filterOptions: PilotFieldSection[];
    provisionOptions: ClauseSuggestions['suggestions'];
    users: string[];
    departments: DepartmentTree[];
    excludedUsers: string[];
    userFields: PilotField[];
    userFieldsSuggestions: {
      label: string;
      id: string;
      name: string;
      value: string;
    }[];
    editAccess: boolean;
    folders: FolderTree[];
  };
};
const initialState: State = {
  config: {
    name: '',
    message: '',
    occurrenceInterval: null,
    occurrencePeriod: null,
    startDate: new Date(),
    occurrenceEndDate: null,
    occurrenceEndTimespan: null,
    occurrenceEndLimit: null,
    filters: [],
    filterOptions: [],
    provisionOptions: [],
    users: [],
    userFields: [],
    departments: [],
    excludedUsers: [],
    userFieldsSuggestions: [],
    editAccess: false,
    folders: [],
  },
};

export default createSlice({
  name: 'alerts',
  initialState,
  selectors: {
    selectConfig: (state) => state.config,
  },
  reducers: {
    setConfig: (state, action) => {
      state.config = action.payload;
    },
    resetAlert: (state) => {
      state.config = initialState.config;
    },
  },
});
